import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_FB_API_KEY,
  authDomain: process.env.REACT_APP_GOOGLE_FB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_GOOGLE_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_GOOGLE_FB_STORAGE_BUKECT,
  messagingSenderId: process.env.REACT_APP_GOOGLE_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_GOOGLE_FB_APP_ID,
  measurementId: process.env.REACT_APP_GOOGLE_FB_MEASUREMENT_ID,
};

// Singleton instances
let app = null;
let analytics = null;
let initialized = false;

/**
 * Initialize Firebase and Analytics
 * @returns {Promise<Analytics|null>} Analytics instance or null if disabled/unsupported
 */
export const initializeFirebase = async () => {
  if (initialized) return analytics;

  /*
  // Check if analytics is enabled via feature flag
  const analyticsEnabled = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';
  if (!analyticsEnabled) {
    console.info('[Analytics] REACT_APP_ENABLE_ANALYTICS is Not Active');
    return null;
  }
   */

  try {
    // Check if analytics is supported in this browser
    const supported = await isSupported();
    if (!supported) {
      console.warn('[Analytics] Not supported in this browser');
      return null;
    }

    // Initialize Firebase app
    app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
    initialized = true;

    console.info('[Analytics] Initialized successfully');
    return analytics;
  } catch (error) {
    console.error('[Analytics] Initialization failed:', error);
    return null;
  }
};

/**
 * Get the analytics instance
 * @returns {Analytics|null} Analytics instance or null if not initialized
 */
export const getAnalyticsInstance = () => analytics;
